import { throwApiError } from '@/lib/errors';
import type { LocalProjectDetail, LocalProjectSummary } from '@/types/project';

const BACKEND_BASE = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

export const projectService = {
  list: async (): Promise<LocalProjectSummary[]> => {
    const response = await fetch(`${BACKEND_BASE}/api/projects/`, { credentials: 'include' });
    if (!response.ok) await throwApiError(response, 'Failed to load SPICE projects');
    return (await response.json()).projects;
  },

  get: async (projectId: number): Promise<LocalProjectDetail> => {
    const response = await fetch(`${BACKEND_BASE}/api/projects/${projectId}`, { credentials: 'include' });
    if (!response.ok) await throwApiError(response, 'Failed to load SPICE project');
    return response.json();
  },
};
